import queryString from 'querystring';
import { subselect } from './root';
import { propertiesSelector } from './properties';
import { linearChannelsFetchByIdSelector } from '../../linearChannels/selectors/fetchById';
import { vodContentFetchItemByIdSelector } from '../../vodContent/selectors/fetchItemById';
import { PLAYER_CONTENT_KIND } from '../constants';
import { VOD_CONTENT_TYPE } from '../../vodContent/constants';

const parseStitcherData = ({ stitched }) =>
  stitched && {
    url: stitched.urls[0].url,
    sessionUrl: stitched.sessionURL,
  };

const linearChannelToContent = (linearChannel, globalState) =>
  linearChannel && {
    kind: PLAYER_CONTENT_KIND.LINEAR_CHANNEL,
    id: linearChannel.id,
    number: linearChannel.number,
    slug: linearChannel.slug,
    featuredImage: linearChannel.featuredImage,
    ...parseStitcherData(linearChannel),
    raw: linearChannel,
    // override url from state with a constructed
    ...(linearChannel.isStitched
      ? { url: `${globalState.application.setup.servers.stitcher}/stitch/hls/channel/${linearChannel.id}/master.m3u8?${queryString.stringify(globalState.application.setup.stitcherParams)}` }
      : {}),
  };

const vodToContent = (VODItem, globalState) =>
  VODItem && {
    kind: PLAYER_CONTENT_KIND.VOD,
    id: VODItem._id,
    type: VODItem.type,
    slug: VODItem.slug,
    serieSlug: VODItem.type === VOD_CONTENT_TYPE.EPISODE ? VODItem.serieSlug : undefined,
    ...parseStitcherData(VODItem),
    raw: VODItem,
    // override url from state with a constructed
    ...(VODItem.isStitched
      ? { url: `${globalState.application.setup.servers.stitcher}/stitch/hls/episode/${VODItem._id}/master.m3u8?${queryString.stringify(globalState.application.setup.stitcherParams)}` }
      : {}),
  };

export const denormalizeContent = (content, globalState) => {
  let denormalizedContent;
  const { id, kind } = content;
  switch (kind) {
    case PLAYER_CONTENT_KIND.LINEAR_CHANNEL:
      const fetchLinearChannelById = linearChannelsFetchByIdSelector(globalState);
      denormalizedContent = linearChannelToContent(fetchLinearChannelById(id), globalState);
      break;

    case PLAYER_CONTENT_KIND.VOD:
      const fetchVODItemById = vodContentFetchItemByIdSelector(globalState);
      denormalizedContent = vodToContent(fetchVODItemById(id), globalState);
      break;

    default:
      denormalizedContent = null;
      break;
  }

  return denormalizedContent;
};

export const contentSelector = (playerState, props, globalState) => {
  const { content } = propertiesSelector(playerState);

  return content ? denormalizeContent(content, globalState) : null;
};

export const playerContentSelector = subselect(contentSelector);

const kindSelector = (playerState) => playerState.content && playerState.content.kind;

export const playerKindSelector = subselect(kindSelector);
